import { Masterdata, IShift, EmployeesService } from "../../services/index";
import { IEmployeeAvailability } from "../../services/employeeAvailability.service";

class EmployeePickerController implements ng.IComponentController {
    onSelectEmployee: any;
    private shift: IShift;
    private employees: any;
    private allEmployees: any;
    private employeeNote: string;
    private employeeAvailability: IEmployeeAvailability[];
    private selectedEmployee: any;
    private activeEmployee: any;
    private functions: Filter[] = [];
    private ranges: any[] = [];
    private availabilities: boolean[] = [];
    private history: boolean[] = [];
    private subscription: boolean[] = [];

    constructor(private $scope: ng.IScope, private SweetAlert: any, private EmployeesService: EmployeesService) {
        'ngInject';
    }

    $onInit = () => {
        this.ranges = [
            {
                name: '0 to 5',
                min: 0,
                max: 5,
                value: false
            },
            {
                name: '5 to 15',
                min: 5,
                max: 15,
                value: false
            },
            {
                name: '15 to 50',
                min: 15,
                max: 50,
                value: false
            },
            {
                name: '50 to 100',
                min: 50,
                max: 100,
                value: false
            },
            {
                name: 'More than 100',
                min: 100,
                max: 5000,
                value: false
            }
        ];

        this.availabilities = [];
        this.history = [];
        this.subscription = [];
        //this.allEmployees = this.employees;


        // this.selectedEmployee = this.employees.find(e => e.employee.id == this.shift.employeeId);

        // this.$scope.$watch('this.shift.employeeId', function(newVal, oldVal){
        //     this.selectedEmployee = this.employees.find(e => e.employee.id == this.shift.employeeId);
        // }, true);
    }

    public $onChanges = (changes) => {
        this.allEmployees = [];
        if (changes.employees) {
            this.allEmployees = this.employees;
            this.filterEmployees();

            if (this.allEmployees && this.allEmployees.length > 0) {
                this.allEmployees.forEach(item => {

                    if (item.isAvailable) {
                        if (item.subscription) {
                            item.order = 1
                        } else if (item.availability) {
                            item.order = 2
                        } else if (!item.availability) {
                            item.order = 4
                        }
                    } else {
                        if (item.subscription) {
                            item.order = 3
                        } else {
                            item.order = 5
                        }
                    }

                });
            }
        }
    }

    employeeSelected(employeeSummary) {

        this.onSelectEmployee();
       
        if(this.selectedEmployee && this.selectedEmployee.employee.id === employeeSummary.employee.id) {
            this.selectedEmployee = null;
            this.shift.employeeId = null;
            return true;
        }

        if (employeeSummary.conflictingShift) {
            this.SweetAlert.swal({
                title: 'Let op!',
                text: 'Deze medewerker heeft al een dienst op dit tijdstip! Wil je deze medewerker alsnog koppelen?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2ECC71',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja',
                cancelButtonText: 'Nee, annuleren',
            }, (isConfirm) => {
                if (isConfirm) {
                    this.selectedEmployee = employeeSummary;
                    this.shift.employeeId = this.selectedEmployee.employee.id;
                } else { }
            });
        } else {
            this.selectedEmployee = employeeSummary;
            this.shift.employeeId = this.selectedEmployee.employee.id;
        }
    }

    employeeActive(employeeSummary) {
        this.activeEmployee = employeeSummary;
    }

    filterEmployees() {
        this.employees = this.allEmployees;
        if (this.functions) {
            var selectedFunctions = this.functions.filter(f => f.value).map(f => f.id);
            if (selectedFunctions.length > 0) {
                this.employees = this.employees.filter(e => selectedFunctions.indexOf(e.employee.functionId) > -1);
            }
        }

        var selectedRanges = this.ranges.filter(r => r.value);
        if (selectedRanges.length > 0) {
            var minRange = Math.min.apply(null, selectedRanges.map(r => parseFloat(r.min)));
            var maxRange = Math.max.apply(null, selectedRanges.map(r => parseFloat(r.max)));
            this.employees = this.employees.filter(e => e.employee.kilometers > minRange && e.employee.kilometers < maxRange);
        }

        if (this.availabilities.filter(a => a).length == 1) {
            if (this.availabilities[0]) {
                this.employees = this.employees.filter(e => e.isAvailable);
            }
            if (this.availabilities[1]) {
                this.employees = this.employees.filter(e => !e.isAvailable);
            }
        }

        if (this.history.filter(a => a).length == 1) {
            if (this.history[0]) {
                this.employees = this.employees.filter(e => e.history);
            }
            if (this.history[1]) {
                this.employees = this.employees.filter(e => !e.history);
            }
        }

        if (this.subscription.filter(a => a).length == 1) {
            if (this.subscription[0]) {
                this.employees = this.employees.filter(e => e.subscription);
            }
            if (this.subscription[1]) {
                this.employees = this.employees.filter(e => !e.subscription);
            }
        }
    }

    removeSubscription(subscription, employeeSummary) {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze inschrijving wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.EmployeesService.customDelete('subscriptions/' + subscription.id).then(() => {
                    employeeSummary.subscription = false;
                });
            } else {

            }
        });
    }
}



class Filter extends Masterdata {
    type: string;
    value: boolean = false;
}

export const employeePickerComponent: ng.IComponentOptions = {
    bindings: {
        shift: '<',
        employees: '<',
        selectedEmployee: '<',
        activeEmployee: '<',
        functions: '<',
        isEmbedded: '<',
        disableFilter: '<',
        disableInfo: '<',
        onSelectEmployee: '&'
    },
    controller: EmployeePickerController,
    template: <string>require('./employeePicker.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/employeePicker.component.ts